export const unifiedMessageContainer = 'unified-message-container';
export const noData = 'No Data';
export const colors = {
  Red: '#FF4229',
  Green: '#BBDB70',
  Yellow: '#FFE982',
  Orange: '#FDA348',
  Blue: '#47AFE8',
  Purple: '#E90076',
  Grey: '#EDEBE4',
};
export const PRODUCT_PAGE = 'PRODUCT_PAGE';
